import { Autocomplete, Box, TextField, ThemeProvider } from '@mui/material';
import PropTypes from 'prop-types';
import {useState } from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { API_KEY_CITY } from '../../config';
import useUtilities from '../../hooks/useUtilities';
import useWindowSize from '../../hooks/useWindowSize';
import { FieldComponentFont } from '../../Styles/componentStyles';
function SearchCity({ setCity, width,label,role,city, name,check}) {
    SearchCity.propTypes = {
        width: PropTypes.any,
        role:PropTypes.any,
        setCity: PropTypes.func,
        city:PropTypes.any,
        name:PropTypes.any,
        label:PropTypes.any,
        check:PropTypes.func,
    };

    // ? you must have as state :       const [localisation,setLocalisation]=useState();
    const {inputSize} = useWindowSize();
    const [citiesList, setCitiesList] = useState([]);
    const { errors, showErrors } =useUtilities();
    const { i18n } = useTranslation();
    const error = name in errors ? errors[name] : undefined;
    // console.log({'ffff': name, errors, showErrors});

    //const [ville,setVille]=useState(null);
    const [firstValue, setFirstValue]=useState({
        country: city?.split('/')[1] ??'',
        is_capital:  false,
        latitude:  0,
        longitude:  0,
        name:  city?.split('/')[0]??'',
        population:  0,
    });

    useEffect(async () => {
        console.log('city avant if',city);
        if(city){
            // ! to make sure that we set the value even the value of city was late
            setFirstValue({
                country: city?.split('/')[1] ??'',
                is_capital:  false,
                latitude:  0,
                longitude:  0,
                name:  city?.split('/')[0]??'',
                population:  0,
            });
            let villeVal=city?.split('/')[0];
            await onChangeCity(villeVal);
            //.then(()=>{
            //    console.log('citiesList after',citiesList);
            //    let pays = citiesList.filter( p => (p['country'] === paysVal));
            //    console.log('pays',pays);
            //    setVille(pays[0]);
            //});
        }
    },[city]);

    //useEffect(() => {
    //    if(citiesList){
    //        console.log('citiesList after',citiesList);
    //        let pays = citiesList.filter( p => (p['country'] === city.split('/')[1]));
    //        console.log('pays',pays);
    //        setVille(pays[0]);
    //    }
    //},[citiesList]);

    const onChangeCity = async (searchedCity) => {
        // ? API restrictions
        console.log('searchcity',searchedCity);
        // let nameQuery = '?name='+ searchedCity + '&limit=10';
        let nameQuery = '?name='+ searchedCity ;
        if(searchedCity ==''){
            nameQuery = '?name=a&limit=10';
            console.log('Nothing inside the nameQUery');
        }
        try {
            const response = await fetch('https://api.api-ninjas.com/v1/city' +nameQuery , {
                method: 'Get',
                headers: {
                    'X-Api-Key': API_KEY_CITY
                },
            });
            const responseData = await response.json();
            console.log('responseData responseData',responseData);
            if(Array.isArray(responseData))
                setCitiesList(responseData);
            // setFirstValue(responseData[0]?.name+ '/' + responseData[0]?.country);
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <Autocomplete
            size={inputSize}
            sx={{ width: { sm: width || 363},
                '& > :not(style)': {borderRadius: '8px'},
            }}
            style={{width:width||'363px'}}
            disabled={role=='visibleOnly' ? true : false}
            freeSolo
            value={firstValue}
            onChange={(event, newValue) => {
                setCity(newValue?.name ? (newValue?.name=='Courbevoic' ?'Courbevoie' : newValue?.name) + '/' + newValue?.country : '');
                if(check)
                    check(false);
                // setFirstValue(newValue?.name + '/' + newValue?.country);
                // ! Strange,but this component doesn't do anything, so I returned to previous way
                // setCity(newValue);
            }}
            options={citiesList}
            autoHighlight
            getOptionLabel={(option) => option?.name? option?.name + '/' + option?.country : ''}
            // https://stackoverflow.com/questions/61947941/material-ui-autocomplete-warning-the-value-provided-to-autocomplete-is-invalid
            isOptionEqualToValue={(option, value) => option.id === value.id}
            renderOption={(props, option) => (
                <Box
                    component="li"
                    sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
                    {...props}
                >
                    <img
                        loading="lazy"
                        width="20"
                        src={`https://flagcdn.com/w20/${option.country.toLowerCase()}.png`}
                        srcSet={`https://flagcdn.com/w40/${option.country.toLowerCase()}.png 2x`}
                        alt=""
                    />
                    {option.name} ({option.country})
                </Box>
            )}
            renderInput={(params) => (
                <ThemeProvider theme={FieldComponentFont}>
                    <TextField
                        value={city}
                        onChange={(event)=>onChangeCity(event.target.value)}
                        {...params}
                        label={i18n.t(label)}
                        //style={{width:'353px',height:'48px',marginTop:'-5px'}}
                        inputProps={{
                            ...params.inputProps,
                            autoComplete: 'off', // disable autocomplete and autofill
                        }}
                        style={{background:'white'}}
                        sx={{'& > :not(style)': {borderRadius: '8px'}}}
                        name={name}
                        helperText={showErrors && (i18n.t(error)?? '')}
                        error={!!error && showErrors}
                    />
                </ThemeProvider>
            )}
        />
    );
}

export default SearchCity;